var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ListCustomerUI',{ref:"ListCustomerUI1",attrs:{"config":_vm.config},on:{"refresh-list":_vm.handleFetchNewData}}),_c('hr'),_c('ListCustomerUI',{ref:"ListCustomerUI2",attrs:{"config":{},"key-refresh-list":_vm.keyRefreshList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }